import { render, staticRenderFns } from "./GroupMemberCard.vue?vue&type=template&id=0c920b6d&"
import script from "./GroupMemberCard.vue?vue&type=script&lang=js&"
export * from "./GroupMemberCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports